import React, { Component } from 'react';
import { GenericError } from 'modules/common';

interface State {
  error: Error | null;
}

export default class ErrorBoundary extends Component<{}, State> {
  state = { error: null };

  componentDidCatch(error: Error) {
    this.setState({ error });
  }

  render() {
    const { error } = this.state;

    if (error !== null) {
      return <GenericError />;
    }

    return this.props.children;
  }
}
